import React, { PureComponent, ReactNode } from 'react'
import './PermitLinkWithColor.scss'
import { LinkContainer } from 'react-router-bootstrap'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IPermit } from '../../StrapiService'
import SanitizeHTML from '../SanitizeHTML'

interface Props {
  permit: IPermit
}

class PermitLinkWithColor extends PureComponent<Props> {
  get backgroundColor() {
    return {
      backgroundColor: this.props.permit.indexAuthBgColor ? this.props.permit.indexAuthBgColor : undefined,
    }
  }
  render(): ReactNode {
    return (
      <LinkContainer to={`/permits/${this.props.permit.permitId}`} className="permit-link-with-color" style={{...this.backgroundColor}}>
        <div>
          <div className={`number${ this.props.permit.indexAuthIconColor ? ' ' + this.props.permit.indexAuthIconColor : '' }`}>
            <img src={process.env.PUBLIC_URL + this.props.permit.iconUrl} />
            <span>{this.props.permit.permitId}</span>
          </div>
          <section className={`${this.props.permit.indexAuthDescColor ?  this.props.permit.indexAuthDescColor : 'dark'}`}> 
            <h2>{this.props.permit.title}</h2>
            <div className="description">
              <SanitizeHTML html={this.props.permit.description} />
              <span className="btn-sm">daugiau informacijos čia <i className="la la-align-left"></i></span>
            </div>
          </section>
          <div className="buttons">
            <Link to={this.props.permit.orderUrl} className="btn primary-button btn-sm btn-block">užsakyti <i className="la la-credit-card"></i></Link>
            {
              this.props.permit.downloadUrl &&
              <Link to={this.props.permit.downloadUrl} className="secondary-button btn btn-sm btn-block">atsisiųsti <i className="la la-download"></i></Link>
            }
            {
              this.props.permit.reportUrl &&
              <Link to={this.props.permit.reportUrl} className="secondary-button btn btn-sm btn-block">ataskaita <i className="la la-list"></i></Link>
            }
          </div>
        </div>
      </LinkContainer>
    )
  }
}

export default PermitLinkWithColor
